<template>
    <div v-loading="loading">
        <div style="line-height: 49px;height: 49px;">
            <button @click="saveComRoleIndustryType()" style="float: right;margin-top: 8px;" class='swb-btn swb-btn-small mr15'>
                <span>保存</span>
            </button>
        </div>
        <ul class="switch-list clearfix ml10">
            <el-checkbox-group v-model="industryTypeIds">
                <li v-for="industryType in industryTypeList" class="switch-item ellipsis-1" style="width: auto;margin-right: 30px;">
                    <el-checkbox :label="industryType.id">
                        <span><i class="icon iconfont icon-wujiaoxingman mr5" style="color: #eaea0f;"></i>{{industryType.name}}</span>
                    </el-checkbox>
                </li>
            </el-checkbox-group>
        </ul>
    </div>
</template>

<script>

    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'
    //
    import servicerAuthxApi from '../../api/servicerAuthx'
    import userApi from '../../api/user'
    import comnApi from '../../api/comn'
    //
    export default {
        name: 'swb-com-role-industy-type',
        desc: '公司岗位-行业类型',
        props: {
            roleId: {
                type: Number,
                default: null
            },
            roleName: {
                type: String,
                default: null
            }
        },
        data: function () {
            return {
                loading: false,
                industryTypeIds: [],
                industryTypeList: []
            }
        },
        created: function () {
            //
            this.getComRoleIndustyTypeTypeIdsByRoleId(this.roleId);
            this.getIndustryTypeList();
        },
        methods: {
            getIndustryTypeList: function () {
                let self = this;
                let postData = {};
                self.loading = true;
                comnApi.getIndustryTypeList(postData, function (result) {
                    self.loading = false;
                    if(result.type === 'info') {
                        let industryTypeList = result.data;
                        self.industryTypeList = industryTypeList;
                    } else {
                        self.$message.error(result.message);
                    }
                });
            },
            getComRoleIndustyTypeTypeIdsByRoleId: function (roleId) {
                let self = this;
                let postData = {};
                postData.roleId = roleId;
                servicerAuthxApi.getServicerComRoleIndustyTypeTypeIdsByRoleId(postData, function (result) {
                    if(result.type === 'info') {
                        self.industryTypeIds = result.data || [];
                    } else {
                        self.$message.error(result.message);
                    }
                });
            },
            saveComRoleIndustryType: function () {
                let industryTypeIds = this.industryTypeIds || [];
                let postData = {};
                postData.roleId = this.roleId;
                postData.typeIds = industryTypeIds;
                //
                let self = this;
                self.loading = true;
                servicerAuthxApi.saveServicerComRoleIndustyTypes(postData, function (result) {
                    self.loading = false;
                    if(result.type === 'info') {
                        self.$message.success("操作成功");
                    } else {
                        self.$message.error(result.message);
                    }
                });
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/authx/ComRoleIndustyType.vue